import React from 'react';
import type { ExplicitFieldAssociationProjectListApp } from '@atlassian/jira-admin-pages-explicit-field-association-project-list/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyExplicitFieldsProjectListPromise = lazyForPaint<
	typeof ExplicitFieldAssociationProjectListApp
>(() => {
	return markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-admin-pages-explicit-field-association-project-list", jiraSpaEntry: "async-admin-pages-explicit-field-association-project-list" */ '@atlassian/jira-admin-pages-explicit-field-association-project-list'
		).then((bundle) => bundle.ExplicitFieldAssociationProjectListApp),
	);
});

export const LazyExplicitFieldsProjectListPage = () => (
	<LazyPage
		Page={LazyExplicitFieldsProjectListPromise}
		pageId="jira-admin-pages-explicit-field-association-project-list"
		shouldShowSpinner
	/>
);
